import { render, staticRenderFns } from "./UploadsPagination.vue?vue&type=template&id=4f7588f8&scoped=true"
import script from "./UploadsPagination.vue?vue&type=script&lang=js"
export * from "./UploadsPagination.vue?vue&type=script&lang=js"
import style0 from "./UploadsPagination.vue?vue&type=style&index=0&id=4f7588f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7588f8",
  null
  
)

export default component.exports